import { OPERATOR_LABELS } from 'constants/SegmentQueryDictionary'
import moment from 'moment'
import React,
{
  Component,
  Fragment
} from 'react'
import { connect } from 'react-redux'

import { Sidebar, Tag } from '@driftt/tide-core'
import { getSegmentQuery } from 'api/segments'

import './style.css'

const SEGMENT_TYPE_DEFS = {
  'Static': 'Static Segments are like snapshots. If you want to update a static segment in the future, you can do it manually.',
  'Dynamic': 'When new contacts are added, they\'ll join this segment if they meet the filter criteria.'
}

const SEGMENT_FILTER_GROUP_MATCH_DEFS = {
  'OR': 'Match some of the following',
  'AND': 'Match all of the following'
}

const mapStateToProps = state => ({ segment: state.__CRM.segmentList.segment })

class SegmentDetailsSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      query: null
    }
  }

  componentWillMount() {
    const { segment } = this.props

    if (segment.type !== 'ID_LIST' && segment.type !== 'QUERY') {
      this.getSegmentQuery()
    }
  }

  getSegmentQuery = async () => {
    const { segment } = this.props

    try {
      const { data } = await getSegmentQuery(segment.id)

      this.setState({
        isLoading: false,
        query: data
      })
    } catch(e) {
      console.log(e)
    }
  }

  getType = (type) => {
    return (type === 'ID_LIST' || type === 'STATIC') ? 'Static' : 'Dynamic'
  }

  renderSegmentFilter = () => {
    const { query } = this.state

    const {
      segmentGroups,
      matchType
    } = query

    return segmentGroups.map((group, i) => {
      return (
        <Fragment>
          <div className="segment-filter-group">
            <section className="segment-filter-group--title">
              <span className="bold">FILTER BY</span> CONTACTS WHO
            </section>
            <div className="segment-filter-group--parameters">
              {this.renderSingleGrouping(group)}
            </div>
          </div>
          {((i + 1) < segmentGroups.length) &&
            <div className="segment-filter--joiner">
              <Tag text={matchType} />
            </div>
          }
        </Fragment>
      )
    })
  }

  resolveRelativeDateFilterValue = ({ value }) => {
    const isBeforeValue = value.rawFromValue === null

    return isBeforeValue ? value.rawToValue : value.rawFromValue
  }

  formatSegmentValue = (operator, segmentValue) => {
    if (operator === 'RELATIVE_DATE_FILTER') {
      return `${this.resolveRelativeDateFilterValue(segmentValue)} Days`
    }
    if (['DATETIME', 'DATE'].includes(segmentValue.type)) {return moment(segmentValue.value).format('DD/MM/YYYY')}
    else {return segmentValue.value}
  }

  renderSingleGrouping = (grouping) => {
    const {
      matchType,
      filters
    } = grouping

    return (
      <Fragment>
        <span>{SEGMENT_FILTER_GROUP_MATCH_DEFS[matchType]}</span>
        {filters.map((filter, i) => {
          const {
            operator,
            segmentProperty,
            segmentValue
          } = filter

          const currentEntityType = filter.segmentValue.type
          const isPresent = operator === 'IS_PRESENT' || operator === 'IS_NOT_PRESENT'
          const isAbsoluteDateOperator = (operator === "IS_BEFORE" && currentEntityType === 'EVENT')||
                                         (operator === "IS_AFTER" && currentEntityType === 'EVENT')


          const segmentDetail  = () => {
            if(isPresent)  {
              return <>{`${segmentProperty.name} ${OPERATOR_LABELS[operator]}`}</>

            } else if(isAbsoluteDateOperator) {
              return <>{`Event ${segmentProperty.name}
                          ${OPERATOR_LABELS[operator] === 'IS_BEFORE' ?
                'first occurred before' : 'last occurred before'}
                          ${moment(segmentValue.value.value).format('MM/DD/YYYY')}`}
                     </>
            } else {
              return <>{`${segmentProperty.name} ${OPERATOR_LABELS[operator]}
                ${this.formatSegmentValue(operator, segmentValue)}`}
                     </>
            }
          }

          return (
            <Fragment>
              <div className="segment-filter--single-filter">
                {segmentDetail()}
              </div>
              {((i + 1) < filters.length) &&
                <div className="segment-filter--single-filter--joiner">
                  <Tag text={matchType} />
                </div>
              }
            </Fragment>
          )
        })}
      </Fragment>
    )
  }

  render() {
    const {
      segment,
      onClose,
      isOpen
    } = this.props
    const { query } = this.state

    return (
      <Sidebar
        isOpen={isOpen}
        close={onClose}
        hideOverlay={true}
        className="single-segment--segment-details-sidebar"
      >
        <header>
          <h3>Segment Details</h3>
        </header>
        <div className="single-segment-details">
          <div className="single-segment-detail-row single-segment-details--name">
            <span>SEGMENT NAME</span>
            <div className="single-segment-detail-row--value">{segment.name}</div>
          </div>
          <div className="single-segment-detail-row single-segment-details--type">
            <span>SEGMENT TYPE</span>
            <div className="single-segment-detail-row--value">{this.getType(segment.type)}</div>
            <div className="single-segment-details--type--definition">
              {SEGMENT_TYPE_DEFS[this.getType(segment.type)]}
            </div>
            {(segment.type === 'QUERY') &&
              <Fragment>
                <span>Copy this to use as a reference to build your new segment</span>
                <code>
                  {JSON.stringify(segment.query, null, 1)}
                </code>
              </Fragment>
            }
            {query && this.renderSegmentFilter()}
          </div>
        </div>
      </Sidebar>
    )
  }
}

export default connect(mapStateToProps, null)(SegmentDetailsSidebar)
